import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { TemplateCreateRequestDto } from "@/dto/TemplatesDto";
import { Yn } from "@/constants/code";

/**
 * 템플릿 생성 폼 Hook
 *
 * @returns
 *
 * @author Max <sud665@ymjlab.com>
 * @version 1.0
 * @since 2025-05-08
 */
export default function useCreateForm(onSubmit: (data: FormData) => void) {
  const methods = useForm<TemplateCreateRequestDto>({
    resolver: yupResolver(
      yup.object().shape({
        file: yup.mixed<File>().required("썸네일 이미지를 선택해주세요."),
        productId: yup.string().required("상품 ID를 선택해주세요."),
        templateNm: yup.string().required("템플릿명을 입력해주세요."),
        templateUrl: yup
          .string()
          .required("템플릿 URL을 입력해주세요.")
          .url("올바른 URL 형식을 입력해주세요."),
        templateDtl: yup.string().required("템플릿 상세 설명을 입력해주세요."),
        dispYn: yup.mixed<Yn>().oneOf([Yn.Y, Yn.N]).default(Yn.Y),
      })
    ),
    defaultValues: {
      productId: "1",
      dispYn: Yn.Y,
    },
  });

  /**
   * 템플릿 생성 폼 제출 핸들러
   *
   * @param data 템플릿 생성 폼 데이터
   */
  const handleSubmit = methods.handleSubmit((data) => {
    // formData 생성
    const formData = new FormData();
    formData.append("file", data.file);
    formData.append("productId", data.productId);
    formData.append("templateNm", data.templateNm);
    formData.append("templateUrl", data.templateUrl);
    formData.append("templateDtl", data.templateDtl);
    formData.append("dispYn", data.dispYn);
    onSubmit(formData);
  });

  return {
    methods,
    handleSubmit,
  };
}
